import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import { LinkCellRenderer } from "../../../../controls/ag-grid/components/ButtonCellRenderer";
type Props = {};
const moment = getMomentTz();
export const useTableData = ({}: Props) => {
	const cellNumberClass = (isFirst: boolean) => {
		return isFirst ? "info-limit" : "info-limit2";
	};

	const columns: (ColDef | ColGroupDef)[] = [
		{
			field: "HeatName",
			headerName: "Heat",
			// cellRenderer: (params: any) => {
			// 	return LinkCellRenderer({
			// 		...params,
			// 		ink: `/heat-report/caster/${params.data.HeatName}`,
			// 	});
			// },
			flex: 1,
			minWidth: 55,
		},
		{
			field: "LadleOpen",
			headerName: "Open",
			flex: 1,
			minWidth: 57,
			cellRenderer: LinkCellRenderer,
			cellRendererParams: { linkProperty: "HeatNameLink" },
			valueGetter: (params) =>
				params.data.LadleOpen
					? moment(params.data?.LadleOpen).format("HH:mm")
					: "",
		},
		{
			headerName: "Nozzle",
			children: [
				{
					field: "NozzleSize",
					headerName: "Size",
					minWidth: 50,
					flex: 1,
				},
				{
					field: "NozzleHeats",
					headerName: "Heats",
					minWidth: 60,
					flex: 1,
					cellClass: (params) => {
						return cellNumberClass(params.data.NozzleFirst);
					},
				},
			],
		},
		{
			headerName: "Ladle",
			children: [
				{
					field: "LadleName",
					headerName: "#",
					minWidth: 50,
					flex: 1,
				},
				{
					field: "HeatsOnLadle",
					headerName: "Heats",
					minWidth: 60,
					flex: 1,
				},
				{
					field: "ContactTimeOnLadle",
					headerName: "Contact Time",
					minWidth: 72,
					wrapHeaderText: true,
					flex: 1,
				},
			],
		},
		{
			headerName: "Tundish",
			children: [
				{
					field: "TundishName",
					headerName: "#",
					minWidth: 50,
					flex: 1,
				},
				{
					field: "TundishHeats",
					headerName: "Heats",
					minWidth: 60,
					flex: 1,
					cellClass: (params) => {
						return cellNumberClass(params.data.TundishFirst);
					},
				},
			],
		},

		{
			headerName: "Shroud",
			children: [
				{
					field: "TundishShroudName",
					headerName: "#",
					minWidth: 50,
					flex: 1,
				},
				{
					field: "TundishShroudHeats",
					headerName: "Heats",
					minWidth: 60,
					flex: 1,
					cellClass: (params) => {
						return cellNumberClass(params.data.TundishShroudFirst);
					},
				},
			],
		},

		{
			headerName: "S1",
			children: [
				{
					headerName: "Housing",
					children: [
						{
							field: "S1HousingName",
							headerName: "Name",
							minWidth: 60,
							flex: 1,
						},
						{
							field: "S1HousingHeats",
							headerName: "Heats",
							minWidth: 60,
							flex: 1,
							cellClass: (params) => {
								return cellNumberClass(params.data.S1HousingFirst);
							},
						},
					],
				},
				{
					headerName: "Mold",
					children: [
						{
							field: "S1MoldName",
							headerName: "Name",
							minWidth: 60,
							flex: 1,
						},
						{
							field: "S1MoldHeats",
							headerName: "Heats",
							minWidth: 60,
							flex: 1,
							cellClass: (params) => {
								return cellNumberClass(params.data.S1MoldFirst);
							},
						},
					],
				},
			],
		},
		{
			headerName: "S2",
			children: [
				{
					headerName: "Housing",
					children: [
						{
							field: "S2HousingName",
							headerName: "Name",
							minWidth: 60,
							flex: 1,
						},
						{
							field: "S2HousingHeats",
							headerName: "Heats",
							minWidth: 60,
							flex: 1,
							cellClass: (params) => {
								return cellNumberClass(params.data.S2HousingFirst);
							},
						},
					],
				},
				{
					headerName: "Mold",
					children: [
						{
							field: "S2MoldName",
							headerName: "Name",
							minWidth: 60,
							flex: 1,
						},
						{
							field: "S2MoldHeats",
							headerName: "Heats",
							minWidth: 60,
							flex: 1,
							cellClass: (params) => {
								return cellNumberClass(params.data.S2MoldFirst);
							},
						},
					],
				},
			],
		},
		{
			headerName: "S3",
			type: ["centerAligned"],
			children: [
				{
					headerName: "Housing",
					type: ["centerAligned"],
					children: [
						{
							field: "S3HousingName",
							headerName: "Name",
							type: ["numericColumn", "numericWidth"],
							minWidth: 58,
							maxWidth: 90,
						},
						{
							field: "S3HousingHeats",
							headerName: "Heats",
							type: ["numericColumn", "numericWidth"],
							minWidth: 58,
							maxWidth: 80,
							cellClass: (params) => {
								return cellNumberClass(params.data.S3HousingFirst);
							},
						},
					],
				},
				{
					headerName: "Mold",
					type: ["centerAligned"],
					children: [
						{
							field: "S3MoldName",
							headerName: "Name",
							type: ["numericColumn", "numericWidth"],
							minWidth: 58,
							maxWidth: 90,
						},
						{
							field: "S3MoldHeats",
							headerName: "Heats",
							type: ["numericColumn", "numericWidth"],
							minWidth: 58,
							maxWidth: 60,
							cellClass: (params) => {
								return cellNumberClass(params.data.S3MoldFirst);
							},
						},
					],
				},
			],
		},
	];

	return { columns };
};
